// src/lib/device.js
import { browser } from "$app/environment";
import { deviceInfo } from "webtonative";

export async function isUserFromApp() {
    // Ensure we're running in a browser environment.
    if (typeof navigator === "undefined" || typeof window === "undefined") {
        return "unknown";
    }


    const userAgent = navigator.userAgent;
    // Check for w2n/iOS in the user agent.
    if (/w2n\/iOS/i.test(userAgent)) {
        return "app";
    }
    // Check for w2n/Android in the user agent.
    if (/w2n\/Android/i.test(userAgent)) {
        return "app";
    }

    // Check if the user agent indicates a mobile device.
    // If it does not, we assume it's a desktop browser.
    if (!/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return "desktop";
    }

    // At this point, we know the device is mobile.
    // It could be either a native app or a mobile browser.
    try {
        const info = await deviceInfo();

        if (!info) {
            // If deviceInfo is not available, assume it's a mobile browser.
            return "mobile";
        }

        // Check if the device info represents a valid app.
        if (
            (info.platform === "android" || info.platform === "ios") &&
            info.installationType?.toLowerCase() !== "debug" &&
            !info.model?.toLowerCase().includes("testing") &&
            info.isPhysicalDevice !== false
        ) {
            return "app";
        }
    } catch (error) {
        // Handle the known error from WebToNative gracefully.
        if (error === "This function will work in Native App Powered By WebToNative") {
            return "mobile";
        }
        console.error("Error retrieving device info:", error);
    }

    // Fallback: if the device is mobile but doesn't meet app criteria,
    // assume it is being accessed via a mobile browser.
    return "mobile";
}


export async function iOsOrAndroid() {
    if (!browser) {
        return "unknown";
    }
    
    // Ensure we're in a browser environment.
    if (typeof navigator === "undefined" || typeof window === "undefined") {
        return "unknown";
    }
    // return either "ios" or "android" based on the device type.
    const userAgent = navigator.userAgent;
    // Check for w2n/iOS in the user agent.
    if (/w2n\/iOS/i.test(userAgent)) {
        return "ios";
    }
    // Check for w2n/Android in the user agent.
    if (/w2n\/Android/i.test(userAgent)) {
        return "android";
    }
    const info = await deviceInfo();
    if (info.platform === "android") {
        return "android";
    } else if (info.platform === "ios") {
        return "ios";
    }
    return "unknown";

}
